import * as SentrySdk from '@sentry/react';
import {
  IS_PRODUCTION,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_INGEST_HOST,
  SENTRY_PROJECT_ID,
  SENTRY_TRACES_SAMPLE_RATE,
} from './buildEnv';
import { resolveSentryDsn } from './sentryDsn';

export * as Sentry from '@sentry/react';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);

function getSentryDsn() {
  return resolveSentryDsn(SENTRY_DSN, SENTRY_INGEST_HOST, SENTRY_PROJECT_ID);
}

export function isSentryEnabled() {
  if (!IS_PRODUCTION) {
    return false;
  }
  if (LOCAL_HOSTS.has(window.location.hostname)) {
    return false;
  }
  return Boolean(getSentryDsn());
}

export function initSentry() {
  if (!isSentryEnabled()) {
    return;
  }

  const dsn = getSentryDsn();
  if (!dsn) {
    return;
  }

  SentrySdk.init({
    dsn,
    environment: SENTRY_ENVIRONMENT,
    integrations: [SentrySdk.browserTracingIntegration()],
    tracesSampleRate: Number(SENTRY_TRACES_SAMPLE_RATE || '0.1'),
  });
}
